import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';

import { Form } from 'components';

const useStyles = makeStyles((theme) => ({
  dropdown: {
    width: '100%'
  },
  menuItem: {
    minHeight: '36px'
  }
}));

const SpecifiersDropdown = (props) => {
  const { schema, specifiers } = props;
  const classes = useStyles();

  return (
    <Form.TextField
      variant="outlined"
      margin="normal"
      select
      id="businessUnit"
      label={schema.label}
      name={`specifier-${schema.name}`}
      size="small"
      className={classes.dropdown}
      onChange={(event) => {
        props.handleChange({
          target: {
            name: 'specifiers', value: {
              ...props.values.specifiers,
              [schema.name]: event?.target?.value
            }
          }
        });
        props.submitForm();
      }}
      value={props.values.specifiers?.[schema.name] || ''}
    >
      {['', ...specifiers[schema.name]].map((v) => (
        <MenuItem className={classes.menuItem} key={v} value={v}>
          {v}
        </MenuItem>
      ))}
    </Form.TextField>
  );
}

export default SpecifiersDropdown;